import { useEffect, lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { initLenis, destroyLenis, scrollToId } from "./lib/smooth";
import { LanguageProvider } from "./i18n/LanguageContext";
import LegalPage from "./pages/LegalPage";
import DeckPage from "./pages/DeckPage";
import SolutionPage from "./pages/SolutionPage";
import { Header } from "./components/krida/Header";
import { Hero } from "./components/krida/Hero";
import { Marquee } from "./components/krida/Marquee";
import { Universe } from "./components/krida/Universe";
import { GameDay } from "./components/krida/GameDay";
import { RoleTiles, RoleBand, ImageryBand } from "./components/krida/Roles";
import { Problem, Lifecycle } from "./components/krida/Platform";
import { ProfileCard } from "./components/krida/ProfileCard";
import { Registry } from "./components/krida/Registry";
import { Careers } from "./components/krida/Careers";
import { ForRoles, ForInstitutions, Government } from "./components/krida/Audiences";
import { Athletes } from "./components/krida/Athletes";
import { Gallery } from "./components/krida/Gallery";
import { About, ClosingCta } from "./components/krida/About";
import { Contact } from "./components/krida/Contact";
import { Footer } from "./components/krida/Footer";

const Dashboard = lazy(() => import("./components/krida/Dashboard").then((m) => ({ default: m.Dashboard })));
const AdminInbox = lazy(() => import("./pages/AdminInbox"));

function App() {
  useEffect(() => {
    initLenis();
    if (window.location.hash) {
      setTimeout(() => scrollToId(window.location.hash), 800);
    }
    return () => destroyLenis();
  }, []);

  return (
    <LanguageProvider>
    <BrowserRouter>
    <Routes>
      <Route path="/admin" element={<Suspense fallback={null}><AdminInbox /></Suspense>} />
      <Route path="/deck" element={<DeckPage />} />
      <Route path="/privacy" element={<LegalPage page="privacy" />} />
      <Route path="/terms" element={<LegalPage page="terms" />} />
      <Route path="/solutions/federations" element={<SolutionPage page="federations" />} />
      <Route path="/solutions/government" element={<SolutionPage page="government" />} />
      <Route path="/solutions/event-workforce" element={<SolutionPage page="event-workforce" />} />
      <Route path="/solutions/academies" element={<SolutionPage page="academies" />} />
      <Route path="/solutions/schools" element={<SolutionPage page="schools" />} />
      <Route path="/solutions/venues" element={<SolutionPage page="venues" />} />
      <Route
        path="/"
        element={
          <div className="App bg-white">
            <Header />
            <main>
              <Hero />
              <Marquee />
              <Universe />
              <RoleTiles />
              <ImageryBand />
              <GameDay />
              <Problem />
              <Lifecycle />
              <Suspense fallback={null}><Dashboard /></Suspense>
              <ProfileCard />
              <RoleBand />
              <ForRoles />
              <Registry />
              <Careers />
              <ForInstitutions />
              <Gallery />
              <Government />
              <Athletes />
              <About />
              <Contact />
              <ClosingCta />
            </main>
            <Footer />
          </div>
        }
      />
    </Routes>
    </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
